// extracted by mini-css-extract-plugin
export var actionText = "_qq-4";
export var container = "_qq-0";
export var leftSection = "_qq-1";
export var rightSection = "_qq-2";
export var settingsButton = "_qq-6";
export var settingsIcon = "_qq-7";
export var shortcut = "_qq-5";
export var shortcutGroup = "_qq-3";